import {
  SkeletonPage,
  Layout,
  LegacyCard,
  SkeletonBodyText,
  TextContainer,
  SkeletonDisplayText,
  BlockStack,
} from "@shopify/polaris";

function SkeltonFallback() {
  return (
    <SkeletonPage primaryAction>
      <Layout>
        <Layout.Section>
          <LegacyCard sectioned>
            <BlockStack gap={"400"}>
              <SkeletonBodyText />
              <div>
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
                <SkeletonDisplayText maxWidth="100%" />
              </div>
            </BlockStack>
          </LegacyCard>
          <LegacyCard sectioned>
            <TextContainer>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText />
            </TextContainer>
          </LegacyCard>
          <LegacyCard sectioned>
            <TextContainer>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText />
            </TextContainer>
          </LegacyCard>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
}
export default SkeltonFallback;
